<template>
    <div ref="slot3_container" class="pub-container-fixed-lateral">
        <ActionButton v-if="AccountController.account.premium.allowed "
            v-tooltip='"messages.ads.tooltip_remove"'
            :gtm="{
                module : 'ads',
                feature: 'ads_remove_modal',
                block  : 'message_list',
                action : 'open'
                }"
            class="close"
            icon="fas fa-times-circle"
            type="icon"
            @click="onRemoveAds()"
        />
        <div class="wrapper">
            <div v-show="slot_item.getFallbackVisibility() === false"
                :id="AdsSlots.GPT_INLINE_BANNER_320_SLOT_3"
                class="GPT_INLINE_BANNER_320_SLOT_3"
            >
            </div>
            <img v-show="slot_item.getFallbackVisibility() === true"
                alt=""
                :src="slot_item.getFallbackSrc()"
                class="GPT_INLINE_BANNER_320_SLOT_3_FALLBACK"
                @click="onFallbackClick()"/>
        </div>
    </div>

</template>

<script setup>
    import ActionButton              from '@/vue/Elements/Buttons/ActionButton.vue';
    import AccountController         from '@/js/Webmail/AccountController';
    import AdsSlotObserverController from '@/js/Webmail/Ads/AdsSlotObserverController';
    import { ref }                   from 'vue';
    import { onBeforeUnmount }       from 'vue';
    import { onMounted }             from 'vue';
    import DomController             from '@/js/Webmail/DomController';
    import AdsSlots                  from '@/js/Webmail/Ads/AdsSlots';
    import GPTAdsController          from '@/js/Webmail/Ads/GPTAdsController';
    import SlotItem                  from '@/js/Webmail/Ads/Items/SlotItem';
    import { reactive }              from 'vue';
    import SAPOMailConfig            from '../../../SAPOMailConfig.js';

    const slot3_container = ref();
    /** @type {SlotItem} */
    const slot_item       = reactive(new SlotItem());

    const emit = defineEmits(['removeAds']);

    onMounted(() => {
        slot_item.setId(AdsSlots.GPT_INLINE_BANNER_320_SLOT_3);
        slot_item.setElement(slot3_container.value);

        DomController.setBodyClass('hasPub');

        GPTAdsController.addQueue(slot_item);
    });
    
    onBeforeUnmount(() => {
        GPTAdsController.removeQueue(slot_item);
    });

    const onRemoveAds = () => {
        emit('removeAds');
    };

    const onFallbackClick = () => {
        if (
            SAPOMailConfig.client.ads
            && SAPOMailConfig.client.ads.fallback
            && SAPOMailConfig.client.ads.fallback.links
            && SAPOMailConfig.client.ads.fallback.links.subscricoes
        ) {
            window.open(SAPOMailConfig.client.ads.fallback.links.subscricoes, '_blank');
        }
    };
</script>

<style>
    .pub-container-fixed-lateral .close {
        position: absolute;
        top: 0;
        right: 0;
        z-index: 1;
    }

    .GPT_INLINE_BANNER_320_SLOT_3 {
        width: 100%;
        height: 100%;
    }

    .GPT_INLINE_BANNER_320_SLOT_3_FALLBACK {
        display: block;
        max-width: 100%;
        cursor: pointer;
    }
</style>
